import { ExternalUserManagement } from "src/api-service";

export interface ExternalUsersState {
    externalUsers: ExternalUserManagement[];
    loaded: boolean;
    loading: boolean;
}

export const initialExternalUsersState: ExternalUsersState = {
    externalUsers: [],
    loaded: false,
    loading: false,
};
